// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { cogDatabase16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-cog-database': IconCogDatabase;
    }
}

/**
 * The icon component for the 'cogDatabase' icon
 */
export class IconCogDatabase extends Icon {
    public constructor() {
        super(cogDatabase16X16);
    }
}

registerIcon('icon-cog-database', IconCogDatabase);
export const iconCogDatabaseTag = 'nimble-icon-cog-database';
